import { CREDIT_CLOSE_REASONS } from '../utils/creditCloseReasons';
import Icon from './Icon';

// The mandatory "why" for closing a credit with no credit document behind it —
// as ONE TAP on a chip, never as typing.
//
// Why chips and not a required text box: this is a repeated bookkeeping action
// (36 such closes in one production window). Mandatory free text on a repeated
// action reliably produces "." and an audit trail that looks like coverage but
// isn't. Three fixed options cover every real case the bookkeeper described, so
// the structured field is always populated; the note beside them is OPTIONAL and
// carries the detail when there is any.
//
// Not rendered at all when a credit document IS linked — the document is the
// record of what happened, and asking again would be ceremony (the same reason
// POST /credits/link-bulk never asks).
//
// `value` is the selected KEY (or ''), `note` the free text. `onChange(key)` /
// `onNoteChange(text)` are controlled by the caller, which also owns the "can't
// confirm yet" state — the picker itself never blocks anything.
export default function CreditCloseReasonPicker({
  value,
  note = '',
  onChange,
  onNoteChange,
  label = 'סיבת הסגירה (חובה — אין מסמך זיכוי מקושר)',
  // Which reasons apply here. Cancelling passes a subset: 'התקבל זיכוי בפועל'
  // cannot be why a credit was CANCELLED — if it was received you mark התקבל —
  // and offering it invites a click that records the opposite of what happened.
  reasons = CREDIT_CLOSE_REASONS,
}) {
  return (
    <div className="form-group" style={{ marginTop: 4 }}>
      <label>{label}</label>
      <div className="reason-chips" role="radiogroup" aria-label="סיבת סגירת הזיכוי">
        {reasons.map(r => {
          const picked = value === r.key;
          return (
            <button
              key={r.key}
              type="button"
              role="radio"
              aria-checked={picked}
              className={`reason-chip${picked ? ' is-picked' : ''}`}
              onClick={() => onChange(r.key)}
            >
              {/* The tick is the only mark on a chip — glyphs come from
                  Icon.jsx, never emoji (they can't take currentColor and
                  break the RTL line box on mobile). */}
              {picked && <Icon name="check" size={14} strokeWidth={2} />}
              {r.label}
            </button>
          );
        })}
      </div>
      <textarea
        className="form-control"
        style={{ marginTop: 10, minHeight: 56, resize: 'vertical' }}
        placeholder="הערה (לא חובה)"
        aria-label="הערת סגירה"
        maxLength={500}
        value={note}
        onChange={e => onNoteChange(e.target.value)}
      />
    </div>
  );
}
